import { date } from '@/public/utils/filter'
import { ENV } from '@/public/config'
import { openVueDevTools } from './utils'
export const carSwipingCard = function () {
  return [
    {
      propertyName: 'startDriver',
      columnName: 'start_driver',
      columnType: 'string',
      operation: 'contain',
      label: '司机姓名',
      type: 'text',
      show: true,
      placeholder: '请填写司机姓名'
    },
    {
      propertyName: 'plateNumber',
      columnName: 'plate_number',
      columnType: 'string',
      operation: 'contain',
      label: '车牌号码',
      type: 'text',
      show: true,
      placeholder: '请填写车牌号码'
    },
    {
      propertyName: 'startGpsKm',
      columnName: 'start_gps_km',
      columnType: 'string',
      operation: 'contain',
      label: '出车里程数',
      type: 'text',
      show: true,
      placeholder: '请填写出车里程数'
    },
    {
      propertyName: 'uploader',
      columnName: 'uploader',
      columnType: 'string',
      operation: 'contain',
      label: '上传人',
      type: 'text',
      show: true,
      placeholder: '请填写上传人'
    }
  ]
}
export const flightSearchDefaultVal = function () {
  return {
    flightDate: date(new Date()),
  }
}
export const flightSearch = function () {
  return [
    {
      'propertyName': 'flightDate',
      'columnName': 's.flight_date',
      'operation': 'equal',
      'columnType': 'date',
      'label': '航班日期',
      'width': 64,
      'show': true,
      'type': 'datePicker',
      'dateType': 'date',
      'attr': {
        'clearable': false
      }
    },
    {
      'propertyName': 'flightNo',
      'columnName': 's.flight_no',
      'operation': 'contain',
      'columnType': 'string',
      'label': '航班号',
      'width': 80,
      'type': 'text',
      'show': true
    },
    {
      'propertyName': 'aircraftType',
      'columnName': 's.aircraft_type',
      'operation': 'contain',
      'columnType': 'enum',
      'label': '机型类型',
      'width': 100,
      'type': 'select',
      'show': true,
      'lookupCode': 'tms_stowage_aircraft_type',
      'unNull': true,
      'attr': {
        'collapse-tags': true,
        'multiple': true
      }
    },
    {
      'propertyName': 'flightStatus',
      'columnName': 's.flight_status',
      'operation': 'contain',
      'columnType': 'enum',
      'label': '航班状态',
      'width': 100,
      'type': 'select',
      'show': true,
      'lookupCode': 'tms_flight_schedule_status',
      'unNull': true,
      'attr': {
        'collapse-tags': true,
        'multiple': true
      }
    },
    {
      'propertyName': 'depAirport',
      'columnName': 's.dep_airport',
      'operation': 'contain',
      'columnType': 'string',
      'label': '始发机场',
      'width': 80,
      'type': 'text',
      'show': true
    },
    {
      'propertyName': 'arrAirport',
      'columnName': 's.arr_airport',
      'operation': 'contain',
      'columnType': 'string',
      'label': '目的机场',
      'width': 80,
      'type': 'text',
      'show': true
    }
  ]
}

export const pointSearch = function () {
  return [
    {
      propertyName: 'pointName',
      columnName: 'p.point_name',
      columnType: 'string',
      operation: 'contain',
      label: '所属点部',
      show: true,
      type: 'text',
      placeholder: '请填写所属点部'
    }
  ]
}

export const distributionScan = function () {
  return [
    {
      propertyName: 'copyType',
      columnName: 'copy_type',
      columnType: 'enum',
      operation: 'contain',
      label: '类型',
      show: true,
      type: 'select',
      lookupCode: 'pda_receipt_copy_type',
      placeholder: '请选择类型'
    },
    {
      propertyName: 'waybillNumber',
      columnName: 'waybill_number',
      columnType: 'string',
      operation: 'contain',
      label: '运单号',
      show: true,
      type: 'text',
      placeholder: '请填写运单号'
    },
    {
      propertyName: 'driverName',
      columnName: 'driver_name',
      columnType: 'string',
      operation: 'contain',
      label: '司机',
      show: true,
      type: 'text',
      placeholder: '请填写司机'
    },
    {
      propertyName: 'receiptByName',
      columnName: 'receipt_by_name',
      columnType: 'string',
      operation: 'contain',
      label: '接收人',
      show: true,
      type: 'text',
      placeholder: '请填写接收人'
    }
  ]
}

export const nodeSearch = function () {
  return [
    {
      propertyName: 'nodeAttrib',
      columnName: 'n.node_attrib',
      operation: 'contain',
      columnType: 'string',
      label: '网点属性',
      type: 'select',
      show: true,
      placeholder: '请选择',
      lookupCode: 'base_data_node_attrib'
    },
    {
      propertyName: 'nodeName',
      columnName: 'n.node_name',
      operation: 'contain',
      columnType: 'string',
      label: '点部名称',
      type: 'text',
      show: true,
      placeholder: '请填写点部名称'
    },
    {
      propertyName: 'departmentName',
      columnName: 'n.department_name',
      operation: 'contain',
      columnType: 'string',
      label: '部门',
      type: 'text',
      show: true,
      placeholder: '请填写部门'
    },
    {
      propertyName: 'nodeType',
      columnName: 'n.node_type',
      columnType: 'enum',
      operation: 'contain',
      label: '场地类型',
      show: true,
      type: 'select',
      lookupCode: 'base_data_node_type',
      placeholder: '请选择场地类型'
    }
  ]
}

export const addressSearch = function () {
  return [
    {
      propertyName: 'depot',
      columnName: 'A.Depot',
      columnType: 'string',
      operation: 'contain',
      label: '所属点部',
      type: 'text',
      show: true,
      placeholder: '请填写所属点部'
    },
    {
      propertyName: 'areaCode',
      columnName: 'S.ZoneCode',
      columnType: 'string',
      operation: 'contain',
      label: '区号',
      type: 'text',
      show: true,
      placeholder: '请填写区号'
    },
    {
      propertyName: 'region',
      columnName: 'CTE_D.Col_012',
      columnType: 'enum',
      operation: 'contain',
      label: '所属区域',
      show: true,
      type: 'select',
      placeholder: '请填写所属区域',
      options: [
        {
          value: '华南',
          label: '华南'
        },
        {
          value: '华北',
          label: '华北'
        },
        {
          value: '华东',
          label: '华东'
        },
        {
          value: '京津冀',
          label: '京津冀'
        }
      ]
    }
  ]
}

export const toolsSearchAuth = {
  flightSearch: 'BTo0UIsxQdmm', // 航班查询
}
export const tools = [
  // {
  //   icon: 'shangchuantubiao',
  //   title: '上传图片'
  // },
  // {
  //   icon: 'paisongliansaomiao',
  //   title: '派送联扫描',
  //   helper: 'distributionScan',
  //   url: 'pda.receiptCopy.search'
  // },
  {
    icon: 'gongju-GPS',
    title: 'GPS定位',
    helper: 'GPSLocation',
    url: 'vms.vehicledispatch.search',
    width: 3,
    view: 'GPSLocation'
  },
  // {
  //   icon: 'gongju-tongxunlu',
  //   title: '通讯录',
  //   view: 'AddressBook',
  //   url: 'hr.remoteEmployee.search',
  //   width: '800px',
  // },
  {
    icon: 'gongju-shuaqia',
    title: '车辆出行刷卡',
    helper: 'carSwipingCard',
    url: 'vms.vehicledispatch.search',
    view: 'carSwingCard'
  },
  {
    icon: 'gongju-hangban',
    title: '航班查询',
    helper: 'flightSearch',
    width: 4.5,
    url: 'baseconfig.flightScheduleInfo.searchScheduleInfo'
  },
  // {
  //   icon: 'dianbuchaxun1',
  //   title: '点部查询',
  //   helper: 'pointSearch',
  //   view: 'Point',
  //   url: 'baseconfig.point.search'
  // },
  // 2023-10-12注释掉
  // {
  //   icon: 'gongju-wangdian',
  //   title: '网点查询',
  //   helper: 'nodeSearch',
  //   width: 5,
  //   url: 'baseconfig.node.search'
  // },
  // {
  //   icon: 'gongju-dizhi',
  //   title: '地址查询',
  //   helper: 'addressSearch',
  //   url: 'address.addressBackground.search'
  // },
  {
    icon: 'gongju-rili',
    title: '考勤日历',
    helper: 'attendanceCalendar',
    view: 'Calendar',
    width: 5,
    url: ''
  },
  {
    icon: 'gongju-duanxin',
    title: '即时短信',
    view: 'Sms',
    width: '1032px',
  },
  // {
  //   icon: 'gongju-rizhi',
  //   title: '升级日志',
  //   view: 'Log',
  //   width: '1000px',
  // },
  {
    icon: 'gongju-jisuanjuli',
    title: '计算距离',
    view: 'Distance',
    width: '532px',
  },
  {
    icon: 'gongju-linshirenwu',
    title: '临时任务',
    func: vm => vm.$router.push('/vms-efficiency/temporary-task/index')
  },
  // {
  //   icon: 'gongju-xunihao',
  //   title: '虚拟号生成',
  //   view: 'VirtualNumber',
  //   width: '840px',
  // },
  {
    icon: 'biaogeshezhi',
    title: '表格配置',
    auth: 'BToY4-xzc0s9',
    func: () => {
      window.__ERP_TABLE_CONFIG_TOOL_OPEN__()
    }
  },
  {
    icon: 'ai',
    title: 'ai造数助手',
    // 仅在开发环境或uat环境显示
    show: () => process.env.NODE_ENV === 'development' || ENV === 'uat',
    func: (vm) => {
      const permission = vm.$store.state.permission.menus || []
      const hasAuth = permission.includes('BTo9+VSb6hAG')
      if (!hasAuth) {
        return vm.$message.warning('无访问权限，请先分配权限')
      }
      const drawer = vm.$refs.dbcDrawer
      drawer.show({
        view: window.__ERP_REMOTE_IMPORT__('dbc/dbcAiMakeNumber'),
        attrs: {
          size: '396px',
          unscroll: true,
          hideHeader: true,
          hightLevel: true,
          closeOnPressEscape: false,
          wrapperClosable: false,
          customWrapStyle: {
            width: '396px',
            left: 'auto',
            overflow: 'visible'
          }
        },
        comListeners: {
          close: () => drawer.close()
        }
      })
    }
  },
  {
    icon: 'biaogeshezhi',
    title: '前端开发工具',
    auth: 'BToYJ3In6EqU',
    show: () => ENV !== 'prd',
    func: () => {
      openVueDevTools()
    }
  }
  // {
  //   icon: 'quanxianxitong',
  //   title: '地图慧密码',
  //   view: 'MapAuth',
  //   width: '360px',
  // }
]

// layout 层的 弹窗的 id
// 即时短信: kye_helper_tools_sms
// GPS定位: kye_helper_tools_gps_location
// 车辆出行刷卡: kye_helper_tools_car_swing_car
// 公共弹窗：kye_helper_tools_common
// 考勤日历：kye_helper_tools_calendar
// 计算距离：kye_helper_tools_distance
// 虚拟号生成：kye_helper_tools_virtual_number
// 工单：kye_kts_work_order_plugin
// 权限申请：kye_tool_auth_apply
// 页面检测：kye_check_rules_box



// WEBPACK FOOTER //
// ./src/shared/home-modules/helpers/form.js